import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin } = usePermissions();
  if (!isAdmin) return <Navigate to="/app/home" replace />;
  return <>{children}</>;
}
